(function(){
  var busy=false,timer;
  function rows(){return [].filter.call(document.querySelectorAll('tr[data-key]'),function(r){var m=r.querySelector('.cart-items__media');return m&&!m.querySelector('.smc-cart-collage')&&/Colour 1:/.test(r.textContent);});}
  function paint(){
    var todo=rows(); if(!todo.length||busy)return; busy=true;
    fetch('/cart.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json();}).then(function(cart){
      cart.items.forEach(function(it){
        var sw=it.properties&&it.properties._swatches; if(!sw)return;
        document.querySelectorAll('tr[data-key="'+it.key+'"] .cart-items__media').forEach(function(m){
          if(m.querySelector('.smc-cart-collage'))return;
          var urls=sw.split('|').slice(0,4), a=document.createElement('a');
          a.href=it.url; a.className='smc-cart-collage smc-cart-collage--'+urls.length;
          a.setAttribute('aria-label',it.product_title+' – your colours');
          urls.forEach(function(u){var i=document.createElement('img');i.src=u;i.alt='';i.loading='lazy';a.appendChild(i);});
          m.innerHTML=''; m.appendChild(a);
        });
      });
    }).catch(function(){}).finally(function(){busy=false;});
  }
  function soon(){clearTimeout(timer);timer=setTimeout(paint,120);}
  document.addEventListener('DOMContentLoaded',paint);
  new MutationObserver(soon).observe(document.documentElement,{childList:true,subtree:true});
})();
